import { render, staticRenderFns } from "./ShieldHome.vue?vue&type=template&id=0405cc3f&scoped=true&"
import script from "./ShieldHome.vue?vue&type=script&lang=js&"
export * from "./ShieldHome.vue?vue&type=script&lang=js&"
import style0 from "./ShieldHome.vue?vue&type=style&index=0&id=0405cc3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0405cc3f",
  null
  
)

export default component.exports